import styled from "styled-components"
import { colors } from "../../../lib/colors"
import {
  tablet2XlText,
  tabletMediumText,
  tabletOperationButton,
  tabletSmallText,
} from "../../../media_queries/TabletMediaQueries"

//TODO create mixins for media queries

interface Elements_Styled_props {
  size?: "s" | "l" | string
  background?: "blue" | "red" | string
  firstBlock?: boolean
  active?: boolean
  disabled?: boolean
  popup?: boolean
}
interface Operation_button_props {
  width?: string
  background?: "blue" | "red" | string
  disabled: any
}
interface Bigcontainer_props {
  removeComponents: boolean
  popup: boolean
}
export const AdditionalInfoWrapper = styled.div<{ autoActive: boolean }>`
  position: absolute;
  width: 100%;
  top: -10px;
  @media only screen and (min-width: 767px) {
    top: ${({ autoActive }) => (autoActive ? "-70px" : "-10px")};
  }
`

export const Bigcontainer = styled.div<Bigcontainer_props>`
  position: relative;
  opacity: ${({ removeComponents }) => (removeComponents ? 0 : 1)};
  transition: opacity 3s;
  display: ${({ popup }) => (popup ? "none" : "block")};
`

export const BetingBlocksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 18px;
  @media only screen and (min-width: 768px) {
    display: grid;
    gap: 18px;
    grid-template-columns: calc(50% - 9px) calc(50% - 9px);
    height: 138px;
    position: relative;
  }
  @media only screen and (min-width: 1024px) {
    margin: 0 0 0 18px;
  }
`
export const BetBlockWrapper = styled.div<Elements_Styled_props>`
  background: rgba(11, 10, 13, 0.8);
  border-radius: 4px;
  color: ${colors.lightGrey};
  font-size: 14px;
  ${tabletMediumText}
  margin-bottom: 18px;
  padding: 20px;
  width: 100%;
  display: flex;
  /* height: fit-content; */
  flex-direction: ${({ firstBlock }) =>
    firstBlock ? "column" : "column-reverse"};
  /* z-index: 1; */
  @media only screen and (min-width: 768px) {
    flex-direction: column;
    position: absolute;
    width: calc(50% - 9px);
    ${({ firstBlock }) => (firstBlock ? "left: 0" : "right: 0")};
    bottom: 0;
    margin-bottom: 0;
  }
`
export const ConfigsWrapper = styled.div<Elements_Styled_props>`
  display: ${({ popup }) => (popup ? "none" : "flex")};
  flex-direction: column;
  flex-direction: ${({ firstBlock }) =>
    firstBlock ? "column" : "column-reverse"};
  @media only screen and (min-width: 768px) {
    flex-direction: column;
  }
`

export const BetBoxWrapper = styled.div<Elements_Styled_props>`
  max-height: 52px;
  display: grid;
  max-height: 52px;
  grid-template-columns: calc(50% - 7px) calc(50% - 7px);
  grid-column-gap: 14px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "auto")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  &&.auto {
    margin: ${({ firstBlock }) => (firstBlock ? "0 0 14px" : "14px 0 0")};
  }
  @media only screen and (min-width: 768px) {
    &&.auto {
      margin: 0 0 14px;
    }
  }
`
export const BetInputWrapper = styled.div`
  display: grid;
  grid-template-columns: calc(100% - 30px) 24px;
  grid-column-gap: 6px;
`

export const InputBox = styled.div<{ focus?: boolean; disabled?: boolean }>`
  background: ${({ focus }) =>
    focus ? "rgba(28,30,36, 0.8)" : "rgba(28,30,36, 0.6)"};
  box-shadow: inset 0px -2.01896px 0px ${({ focus }) => (focus ? "transparent" : "#292933")};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 4px 0 0 12px;
  display: flex;
  transition: all 0.3s;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "auto")};
  input {
    background: none;
    outline: none;
    border: none;
    font-size: 24px;
    ${tablet2XlText}
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    &::placeholder {
      color: white;
      opacity: 1;
    }
  }
  label {
    text-align: left;
    line-height: 1;
    padding: 4px 0 2px;
    user-select: none;
  }
`
export const InputWrapper = styled.div<{ focus?: boolean; disabled?: boolean }>`
  display: flex;
  transform: ${({ focus }) => (focus ? " scale(0.9)" : "scale(1)")};
  transition: transform 0.3s;
  transform-origin: left;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  padding-bottom: 4px;
`
export const OperationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 3px;
`

export const OperationButton = styled.div<Operation_button_props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: ${({ background }) =>
    background === "red" ? colors.redGradient : colors.blueGradient};
  box-shadow: inset 0px -3px 0px ${({ background }) => (background === "red" ? colors.red : colors.blue)};
  font-size: 12px;
  ${tabletSmallText}
  ${tabletOperationButton}
  text-align: center;
  border-radius: 4px;
  color: white;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  user-select: none;
  transform: scale(1);
  transition: all 0.167s cubic-bezier(0.39, 0.575, 0.565, 1);
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  :active {
    transform: ${({ disabled }) => (disabled ? "" : "scale(0.9)")};
    transition: all 0.167s cubic-bezier(0.39, 0.575, 0.565, 1);
  }
  @media only screen and (min-width: 1024px) {
    font-size: 16px;
  }
`

export const ButtonWrapper = styled.div<Elements_Styled_props>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  width: 100%;
  height: 100%;
  font-size: 24px;
  ${tablet2XlText}
  text-align: center;
  color: white;
  user-select: none;
  transform: scale(1);
  transition: all 0.167s cubic-bezier(0.39, 0.575, 0.565, 1);
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  border-radius: ${({ size }) => (size === "s" ? "4px" : "6px 6px 4px 4px;")};
  span {
    line-height: 0.8;
  }
  :active {
    transform: ${({ disabled }) => (disabled ? "" : "scale(0.9)")};
    transition: all 0.167s cubic-bezier(0.39, 0.575, 0.565, 1);
  }
  @media only screen and (min-width: 1024px) {
    font-size: 26px;
  }
`
export const Button = styled.div<Elements_Styled_props>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ background }) =>
    background === "green" ? "column" : ""};
  box-shadow: inset 0px -3.02844px 0px ${({ background }) => (background === "red" ? colors.red : background === "green" ? colors.green : colors.blue)};
  border-radius: ${({ size }) => (size === "s" ? "4px" : "6px 6px 4px 4px;")};
  background: ${({ background }) =>
    background === "red"
      ? colors.redGradient
      : background === "green"
      ? colors.greenGradient
      : colors.blueGradient};
  .state {
    text-transform: uppercase;
  }
`
export const NumberOfBets = styled.span`
  padding-left: 5px;
`

export const ActionButton = styled.div<Elements_Styled_props>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: solid 1px;
  user-select: none;
  border-color: ${({ active }) =>
    active ? "rgba(223, 46, 46, 0.6)" : "#272730"};
  margin: ${({ firstBlock }) => (firstBlock ? "0 0 14px" : "14px 0 0")};
  transition: all 0.3s;
  background-color: ${({ active }) =>
    active ? "rgba(223, 46, 46, 0.4)" : "rgba(22, 22, 28, 0.3)"};
  color: ${({ active }) => (active ? "#DB2D2D" : "#868B9E")};
  transition-property: color, background-color, border-color;
  height: 26px;
  font-size: 14px;
  ${tabletMediumText}
  line-height: 100%;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  :hover {
    transition: all 0.3s;
    transition-property: color, background-color, border-color;
  }
  @media only screen and (min-width: 768px) {
    margin: 0 0 20px;
  }
`
export const Currency = styled.div`
  line-height: 100%;
  font-size: 24px;
  ${tablet2XlText}
  display: flex;
  align-items: center;
  color: #ffffff;
  margin-right: 2px;
  /* transform: translateY(-4px); */
  /* margin-top: 1px; */
  /* -webkit-margin-top: 1px; */
`
